// extracted by mini-css-extract-plugin
module.exports = {"root":"Tooltip-root-3nNPO","tooltip":"Tooltip-tooltip-1XxcE","title":"Tooltip-title-170fa","contents":"Tooltip-contents-uE83k"};